import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataTablesService } from '../../../../../../core';
import { Produtividade } from '../../adapters';
import { RepresentanteProdutividadeGeralKPITableState } from './representante-produtividade-geral-kpi-table.state';
import { RepresentanteProdutividadeGeralKPITableStateService } from './representante-produtividade-geral-kpi-table.state.service';

@Component({
    selector: 'sgt-representante-produtividade-geral-kpi-table',
    templateUrl: './representante-produtividade-geral-kpi-table.component.html',
    styleUrls: ['./representante-produtividade-geral-kpi-table.component.less'],
    providers: [
        RepresentanteProdutividadeGeralKPITableStateService
    ]
})
export class RepresentanteProdutividadeGeralKPITableComponent implements OnInit, OnDestroy {
    /** State do component */
    state: RepresentanteProdutividadeGeralKPITableState;
    /** Subscription do state do component */
    private state$: Subscription;
    /** Dados dos KPIs de produtividade dos representantes */
    @Input() data: Produtividade;

    // Datatable
    isCreatingDataTable: boolean
    @Input() idDataTable = 'representanteProdutividadeGeralKPITable';
    private dataTable: any;

    constructor(private dataTablesService: DataTablesService,
                private stateService: RepresentanteProdutividadeGeralKPITableStateService) { }

    ngOnInit(): void {
        this.initState();
    }

    /** Inicializando o state do component */
    private initState() {
        // State
        this.state$ = this.stateService.init(false).subscribe(state => this.state = state);
    }

    /** Cria a dataTable */
    private createTable(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                columnDefs: [
                    {orderable: true, targets: 0}
                ],
                order: [[1, 'asc']],
                searching: false,
                info: false,
                paging: false,
                processing: true,
            }).then(dataTable => {
                this.dataTable = dataTable;
                resolve();
            })
            .catch(() => {});
        });
    }

    show(periodicidade: number) {
        this.stateService.setPeriodicidade(periodicidade);

        if (this.dataTable) {
            this.dataTablesService.destroyTable(this.dataTable);
            this.dataTable = null;
        }

        this.createTable();
    }

    ngOnDestroy(): void {
        this.state$?.unsubscribe();
        this.dataTablesService.destroyTable(this.dataTable);
    }
}
